class MultipleCollections extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      options: this.querySelectorAll(".select_collection"),
      collections: this.querySelectorAll(".collection__item"),
    };

    this.init();
  }

  init() {
    const paramsURL = new URLSearchParams(window.location.search);
    const utm_content = paramsURL.get("utm_content");

    if (utm_content && this.elements.options.length > 1) {
      this.elements.options.forEach((option) => {
        if (option.dataset.content == utm_content) {
          option.classList.add("active");
        }
      });

      this.elements.collections.forEach((collection) => {
        if (collection.dataset.content == utm_content) {
          collection.classList.add("active");
        }
      });
    } else {
      if (this.elements.options[0]) this.elements.options[0].classList.add("active");
      if (this.elements.collections[0]) this.elements.collections[0].classList.add("active");
    }

    this.elements.options.forEach((option) => {
      option.addEventListener("click", this.handleOptionChange.bind(this));
    });
  }

  handleOptionChange(event) {
    this.elements.options.forEach((option) => {
      option.classList.remove("active");
    });

    let selection =
      Array.from(event.target.classList).find((elements) => elements === "select_collection") == undefined
        ? event.target.parentElement
        : event.target;

    selection.classList.add("active");

    let value = selection.dataset.index;

    this.elements.collections.forEach((collection) => {
      collection.classList.remove("active");
      if (collection.dataset.index == value) {
        Array.from(collection.classList).find((item) => item == "active") == undefined
          ? collection.classList.add("active")
          : collection.classList.remove("active");
      }
    });
  }
}

customElements.define("multiple-collections", MultipleCollections);
